<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Ürün Soruları">
          <!-- <b-alert variant="warning" show class="mb-0">
              <div class="alert-body mb-2">
                <span><strong>Not:</strong> Çevirisi güncellenecek Ürün benzersiz olmalıdır...</span>
              </div>
            </b-alert> -->
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/product-question/create/${id}`"
          >
            Yeni Ürün Sorusu Ekle
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Ürün Sorusu Liste Formu">
            <b-row>
              <b-col cols="12">
                <div class="text-center">
                  <h4>
                    Ürün Adı: <b>{{ name }}</b>
                  </h4>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="text-center">
                  <img
                    class="img-fluid"
                    width="70px"
                    :src="productImage"
                    alt="image slot"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-card class="mb-3" title="Çeviriler">
                  <b-form>
                    <b-row>
                      <b-col cols="12">
                        <table class="table b-table table-responsive">
                          <thead>
                            <th>#</th>
                            <th>Soru</th>
                            <th>Çarpım</th>
                            <th>OLUŞTURMA TARİHİ</th>
                            <th>İŞLEMLER</th>
                          </thead>
                          <draggable
                            v-model="productQuestions"
                            class="cursor-move"
                            tag="tbody"
                            @change="outputData"
                          >
                            <tr
                              v-if="productQuestions.length > 0"
                              v-for="productQuestion in productQuestions"
                              :key="productQuestion.id"
                            >
                              <td>{{ productQuestion.id }}</td>
                              <td>{{ productQuestion.question.question }}</td>
                              <td>{{ productQuestion.multiplied }}</td>
                              <td>{{ productQuestion.createdAt }}</td>
                              <td>
                                <b-button-group>
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    variant="outline-warning"
                                    class="btn-icon rounded-circle mr-2"
                                    :to="`/product-question/edit/${productQuestion.id}`"
                                  >
                                    <feather-icon icon="EditIcon" />
                                  </b-button>
                                </b-button-group>
                                <b-button-group>
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    variant="outline-danger"
                                    class="btn-icon rounded-circle"
                                    @click="deleteConfirmText(productQuestion.id)"
                                  >
                                    <feather-icon icon="TrashIcon" />
                                  </b-button>
                                </b-button-group>
                              </td>
                            </tr>
                          </draggable>
                          <thead>
                            <th>#</th>
                            <th>Soru</th>
                            <th>Çarpım</th>
                            <th>OLUŞTURMA TARİHİ</th>
                            <th>İŞLEMLER</th>
                          </thead>
                        </table>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BButtonGroup,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BButtonGroup,

    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
    draggable,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: this.$route.params.idParam,
      targetLocale: this.$route.query.targetLocale,
      name: "",
      productImage: null,
      productQuestions: [],
      questions: [],
      isDraft: false,
      spinner: false,
      request:[],
      chars: {
        name: 1000,
      },
    };
  },
  watch: {},
  methods: {
    outputData() {
      this.updateSubmit();
    },

    getProductById() {
      endpoints
        .getProductById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.name = data.response.name;
          this.productImage = data.response.images.productImage;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductQuestionsById() {
      endpoints
        .getProductQuestionsById(this.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.productQuestions = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateSubmit() {
      Object.entries(this.productQuestions).forEach(([key, value]) => {
        let productQuestionsOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(productQuestionsOrder);
      });
      endpoints
        .putProductQuestionsOrder(
          { productQuestions: this.request },
          this.$i18n.locale,
          () => {}
        )
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Ürün soru sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Ürün sorularını güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("id", this.id);
          formData.append("name", this.name);
          formData.append("subText", this.subText);
          formData.append("mealMatch", this.mealMatch);
          formData.append("alcoholTasteNotes", this.alcoholTasteNotes);
          formData.append("colors", this.colors);
          formData.append("alcoholValue", this.alcoholValue);
          formData.append("isDraft", this.isDraft ? 1 : 0);
          if (this.$refs.refProductImage.image != null) {
            formData.append("productImage", this.$refs.refProductImage.image);
          }
          if (this.$refs.refProductBgImage.image != null) {
            formData.append("productBgImage", this.$refs.refProductBgImage.image);
          }
          if (this.$refs.refProductCircleImage.image != null) {
            formData.append("productCircleImage", this.$refs.refProductCircleImage.image);
          }

          endpoints
            .putProductTranslation(formData, this.targetLocale, () => {})
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Ürün soruları güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/product-questions`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Ürün sorusu benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    deleteConfirmText(id) {
      this.$swal({
        title: "Sil?",
        text: "Ürün sorusunu silmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteSubmit(id);
        }
      });
    },
    deleteSubmit(id) {
      endpoints
        .deleteProductQuestion(id, this.$i18n.locale, () => {})
        .then((data) => {
          this.getProductQuestionsById();
          this.$swal({
            icon: "success",
            title: "Silme başarılı!",
            text: "Ürün sorusu silindi",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getProductById();
    this.getProductQuestionsById();
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
